<template>
  <div>
    <div class="profile-header__user-image">
      <img :src="preview" alt="" style="width: 100%; min-height: 160px; background: rgba(255,255,255,0.5)">
		</div>
    <input
      type="file"
      style="display:none"
      ref="photo"
      accept="image/*"
      @change="onFilePicked"
    />
    <v-btn color="warning" @click="reset">Cancel</v-btn>
    <v-btn v-if="!file" color="success" @click="selectPhoto">Select Photo</v-btn>
    <v-btn v-else color="success" @click="upload" :loading="imageUploading">Confirm</v-btn>
  </div>
</template>

<script>
import axios from 'axios'
import {mapActions} from 'vuex'
export default {
  name: 'profile-picture-upload',
  data () {
    return {
      file: null,
      preview: null,
      filename: '',
      imageUploading: false
    }
  },
  methods: {
    ...mapActions([
      'setUserProp'
    ]),
    selectPhoto () {
      this.$refs.photo.click()
    },
    onFilePicked (event) {
      console.log(event.target.files)
      const files = event.target.files
      let filename = files[0].name
      this.filename = filename
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.preview = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.file = files[0]
    },
    upload() {
      if (!this.file) {
        return
      }
      this.imageUploading = true
      let formData = new FormData()
      formData.append('filename', this.filename)
      formData.append('image', this.file)
      axios({
				method: 'post',
				url: '/api/v1/user-image-upload/',
				data: formData
			})
				.then(response => {
          console.log(response)
          this.$emit('noEditPhoto')
          this.imageUploading = false
          this.setUserProp({avatar: this.preview})
				})
				.catch(error => {
					console.error(error)
				})
    },
    reset () {
      this.$refs.photo.value = ''
      this.file = null
      this.preview = null
      this.$emit('noEditPhoto')
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-header {
	text-align: center;
	&__user-image {
		width: 100%;
		padding: 2px;

		overflow: hidden;
		text-align: center;
		img {
			object-fit: cover;
			border: 5px solid #fafafa;
			border-radius: 50%;
			width: 50%;
			max-width: 200px;
		}
	}

	&__user-name {
		font-size: 2em;
	}
}
</style>
